export const PIE_CHART_MAX_SLICE_COUNT = 10;

export const COMMENTARIES_MAX = 10;

export const FOLDER_TITLE_LIMIT = 200;
